import _extends from "babel-runtime/helpers/extends";
import React from "react";
import Route from "react-router-dom/Route";
import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";

import Home from "./pages/Home";
import Play from "./pages/Play";
import Registration from "./pages/Registration";
import Page404 from "./pages/Page404";
import quizzService from "./stores/quizz";

var withResetGame = compose(
// Reset game when loading the page
connect(function () {
  return {};
}, function (dispatch) {
  return {
    reset: function reset() {
      return dispatch(quizzService.reset());
    }
  };
}), lifecycle({
  componentDidMount: function componentDidMount() {
    this.props.reset && this.props.reset();
  }
}));

var routes = {
  home: {
    path: "/",
    to: function to() {
      return routes.home.path;
    },
    match: function match(props) {
      return function (Component) {
        return React.createElement(Route, _extends({
          exact: true,
          path: routes.home.path,
          component: Component
        }, props));
      };
    }
  },
  play: {
    path: "/play",
    to: function to() {
      return routes.play.path;
    },
    match: function match(props) {
      return function () {
        var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Play;
        return React.createElement(Route, _extends({ exact: true, path: routes.play.path, component: withResetGame(Component) }, props));
      };
    }
  },
  registration: {
    path: "/register/:type",
    to: function to(_ref) {
      var type = _ref.type;
      return routes.registration.path.replace(":type", type);
    },
    match: function match(props) {
      return function () {
        var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Registration;
        return React.createElement(Route, _extends({ path: routes.registration.path, component: Component }, props));
      };
    }
  },
  error404: {
    match: function match(props) {
      return function () {
        var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Page404;
        return React.createElement(Route, _extends({ component: Component }, props));
      };
    }
  }
};

export default routes;
//# sourceMappingURL=routes.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/routes.js
// module id = 22
// module chunks = 0